const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  creditBalanceSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  creditBalanceHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '8px',
    height: '40px',
    background:
      'linear-gradient(90deg, rgba(80, 167, 255, 0.08) 0%, rgba(92, 104, 250, 0.08) 78.4%)',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#015ffb',
  },
  creditIcon: {
    fontSize: '20px',
    color: '#015ffb',
  },
  sectionBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '8px',
    padding: '16px',
    background:
      'linear-gradient(90deg, rgba(80, 167, 255, 0.08) 0%, rgba(92, 104, 250, 0.08) 78.4%)',
  },
  lastSectionBox: {},
  sectionHeader: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionHeaderWithMargin: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0',
  },

  lightningIcon: {
    color: '#ffc107',
  },
  lightbulbIcon: {
    color: '#ffc107',
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '14px',
  },
  sectionDescription: {
    fontSize: '14px',
    fontWeight: 400,
  },
  seeDetailsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  seeDetailsLink: {
    cursor: 'pointer',
    color: '#637381',
    fontSize: '14px',
  },
  arrowIcon: {
    color: '#637381',
    fontSize: '24px',
    transition: 'transform 0.3s ease',
  },
  arrowIconRotated: {
    transform: 'rotate(180deg)',
  },
  featuresContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #E5E7EB',
  },
  tableHeaderText: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#637381',
    '&:first-child': {
      width: '40%',
    },
    '&:last-child': {
      width: '60%',
    },
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid #E5E7EB',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  creditCostDoubleCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '60%',
  },
  featureTitle: {
    fontWeight: 400,
    fontSize: '14px',
    width: '40%',
  },
  creditCostCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'flex-start',
  },
  creditIconSmall: {
    fontSize: '16px',
  },
  creditCostText: {
    fontSize: '14px',
    fontWeight: 400,
  },
}

export default styles
